export default "__VITE_ASSET__DM$1xqjj__"